import Card from "@/main/components/shared/card/card";
import { useUserReducer } from "@/main/store/user";

import { useCreateOrderContext } from "../../../../context";
import CardGridPart from "../cardGridPart/cardGridPart";
import { IGridPartInternalProps, IGridPartProps } from "../interface";
import RowGridPart from "../rowGridPart/rowGridPart";

function GridPartFactory(props: IGridPartProps) {
	const userReducer = useUserReducer();
	useCreateOrderContext();

	const isCollumnGrid = userReducer.userPreference.preferences.isViewCard;

	const customProps: IGridPartInternalProps = {
		...props,
		isCollumnGrid,
	};

	return (
		<Card
			{...props}
			className={`${isCollumnGrid ? "" : "box-layout-card-collumn"}`}
			maxWidth={isCollumnGrid ? "400px" : "100%"}
			style={{
				height: isCollumnGrid ? "140px" : "50px",
			}}
		>
			<CardGridPart {...customProps} />
			<RowGridPart {...customProps} />
		</Card>
	);
}

export default GridPartFactory;
